import { useCallback } from "react";

type Status = "info" | "error" | "event" | "warning" | "success";
type Event = "order-transmission" | "order-replication" | "order-deletion" | "order-save" | "order-update";

export const useLogger = () => {
	const log = useCallback(
		(
			status: Status,
			event: Event,
			message: string,
			details?: any,
		) => {
			// Log removido - audit/log não é mais usado no sistema
			console.log(`[${status.toUpperCase()}] ${event}: ${message}`, details);
		},
		[],
	);

	return { log };
};

